module.exports = __webpack_public_path__ + "static/img/bg-15-1.85eee93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-15-1.png
// module id = 1LDi
// module chunks = 0